import { render, staticRenderFns } from "./BRCyberSecurity.vue?vue&type=template&id=6910b274&"
import script from "./BRCyberSecurity.vue?vue&type=script&lang=js&"
export * from "./BRCyberSecurity.vue?vue&type=script&lang=js&"
import style0 from "./BRCyberSecurity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports